import { render, staticRenderFns } from "./SimpleColorTag.vue?vue&type=template&id=47827f6f&"
import script from "./SimpleColorTag.vue?vue&type=script&lang=js&"
export * from "./SimpleColorTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports